import { Component, OnInit } from '@angular/core';
import { PescadorService } from './../../services/solicitante/pescador.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { SolicitanteService } from 'src/app/services/solicitante/solicitante.service';
import { Pescador } from './../../models/pescador';
import { forkJoin, pipe } from 'rxjs';
import { Router } from '@angular/router';
import { async } from '@angular/core/testing';
import { formatDate } from '@angular/common';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-recibospost',
  templateUrl: './recibospost.component.html',
  styleUrls: ['./recibospost.component.css']
})
export class RecibospostComponent implements OnInit {

  format = 'dd/MMM/yyyy';
  fechaActual: string;
  empresa: string;
  email: string;
  direccion: string;
  ciudad: string;
  estado: string;
  pipe: Date;
  totalsumatoriatabla: number;
  identificadocompra: string;
  listapescador: Pescador[];
  identificadousuario: string;
  numerorecibo: string;
  numerotocket: string;
  total: number;

  pagina: string;

  constructor(
    private solicitanteService: SolicitanteService,
    private usuarioService: UsuarioService,
    private pescadorService: PescadorService,
    private router: Router,
    public dialogRef: MatDialogRef<RecibospostComponent>
  ) { }

  ngOnInit() {
    this.empresa = '';
    this.email = '';
    this.fechaActual = '';
  this.identificadousuario = '';


    this.identificadocompra = localStorage.getItem('idmovimiento');
    // this.pagina = localStorage.getItem('pagina');





  }



  crearReporte() {

    const doc = new jsPDF();

    const img = new Image();
    img.src = '../../../assets/logo.jpg';
    doc.addImage(img, 'jpg', 10, 10, 200, 60);
    // doc.addImage(img, 'jpg', 10, 10, 200, 65);
    // doc.text('Recibo de Compra de Licencias en SportFishingMX :{{misdatos}}', 100, 70, 'center');


    let valortop = 90;
    const espacios = 7;
    const margen = 15;


    const fechaactual = new Date();


    const locale = 'en-US';
    const formattedDate = formatDate(fechaactual, this.format, locale);


    doc.setFontSize(14);
    doc.setFontType('bold');
    doc.text(margen, valortop, 'Date: ' );
    doc.setFontType('normal');
    doc.text(margen + 50, valortop,  formattedDate );
    valortop += 7;
    doc.setFontSize(14);
    doc.setFontType('bold');
    doc.text(margen, valortop, 'Name: ' );
    doc.setFontType('normal');
    doc.text(margen + 50, valortop,  this.empresa );
    valortop += 7;
    doc.setFontType('bold');
    doc.text(margen, valortop, 'Email: ' );
    doc.setFontType('normal');
    doc.text(margen + 50, valortop, this.email);

    valortop += 7;
    doc.setFontType('bold');
    doc.text(margen  , valortop, 'Address: ' );
    doc.setFontType('normal');

    doc.text(margen + 50 , valortop,  this.direccion);
    valortop += 7;
    doc.setFontType('bold');
    doc.text(margen , valortop, 'City: ');
    doc.setFontType('normal');
    doc.text(margen + 50 , valortop, this.ciudad);

    doc.setFontType('bold');
    doc.text(margen + 120, valortop, 'State: ' + this.estado);
    doc.setFontType('normal');
    valortop += 7;
    doc.text(margen, valortop, 'Receipt Number: ' + this.numerorecibo);
    valortop += 7;
    doc.text(margen, valortop, 'Confirmation Number: ' + this.numerotocket);



    doc.text(150, 270, 'Total Pay: ' + this.totalsumatoriatabla.toFixed(2) + ' USD');


    const res = doc.autoTableHtmlToJson(document.getElementById('basic-table'));
    doc.autoTable(res.columns, res.data, {margin: {top: 140}});

    doc.save('ticket.pdf');

    if (this.pagina === 'publico') {
    this.router.navigateByUrl('');
    } else if (this.pagina === 'gestor') {
      // alert ('estamos en gestores');
       this.router.navigate(['../fantasma']);
    //   this.router.navigate(['../gestores']);
      } else if (this.pagina === 'landing') {
        this.router.navigate(['../landing']);

  }

    this.cerrarventana();
}







    localizaTicket() {


    this.solicitanteService.buscarReciboSolicitante( this.identificadousuario )
    .subscribe ( resp => {
       this.fechaActual = resp.creado;
       const valorUsuario = resp.idusuario;
       this.numerorecibo = resp.numeroperacion;
       this.numerotocket = resp.numeroconfirmacion;

      // console.log ("id del usuario", resp.idusuario);
       if (valorUsuario !== 'N/A') {

      this.usuarioService.LocalizaInfoUsuarios(resp.idusuario)
      .subscribe (res => {
          this.empresa = res.nombreEmpresa;
          this.email = res.email;
          this.direccion = res.direccion;
          this.ciudad = res.ciudad;
          this.estado = res.estado;





      });
    } else {
      this.empresa = resp.nombre;
      this.email = resp.email;
      this.direccion = '';
      this.ciudad = '';
      this.estado = '';

    //  this.empresa = resp.nombre;
    //  this.email = resp.email;
    }

       this.muestratodospescador(this.identificadousuario);
    });





  }




  muestratodospescador( valoID ) {
    this.pescadorService.nuestraTodosPescadores ( valoID )
      .subscribe(
        listado => {

         // this.totalListadoPescador = this.pescadorService.totalListadoPescador;

          this.listapescador = listado;


          this.totalsumatoriatabla = this.listapescador.reduce((acc,  obj,  ) => acc + (obj.costolicencia), 0);
          console.log (this.totalsumatoriatabla);

          (async () => {
            // Do something before delay

             await this.delay(1000);

            // Do something after
             this.crearReporte();
        })();







    // Calculamos el TOTAL
      //    this.totalsumatoriatabla = this.listapescador.reduce((acc,  obj,  ) => acc + (obj.costolicencia), 0);
       //   console.log ( 'sumatorioa' + this.totalsumatoriatabla );

   // this.collectionSize = this.listapescador.length;

         },
         err => console.log (err)

        );




  }




  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
}



cerrarventana() {
  this.dialogRef.close();
}


}
